export class FilterLookup {
  innerMap = new Map();

  add(parameter, id) {
    if (!this.innerMap.has(parameter)) {
      this.innerMap.set(parameter, []);
    }

    this.innerMap.get(parameter).push(id);
  }

  getByParameter(parameter) {
    if (this.innerMap.has(parameter)) {
      return this.innerMap.get(parameter);
    }
    return [];
  }

  getByFieldId(id) {
    const parameters = [];
    for (const [parameter, ids] in this.innerMap.entries()) {
      if (ids.includes(id)) {
        parameters.push(parameter);
      }
    }

    return parameters;
  }
}
